import { type Fights } from '@/entities/leaderboards/model/pvp.types';
import type {
  LeaderboardContestType,
  LeaderboardsByCategory,
  UserLeaderboard,
  WinnerByLBCategory,
} from '@/entities/leaderboards/model/types';
import { type MarketItem } from '@/entities/market/model/market.types';
import { type Tasks } from '@/entities/task/model/task.types';
import { type Prize } from '@/entities/wheel/model/wheel.types';

import { type PageableOptions, type PageableRes } from '@/shared/types/common';

import { api } from '../api';

export const getLeaderboards = () => {
  return api.get<LeaderboardsByCategory>('/v1/leaderboards').then((res) => {
    return res.data;
  });
};

export const getLeaderboardUsers = (
  id: number,
  { page = 0, size = 10, sort = 'asc' }: PageableOptions = {}
): Promise<PageableRes<UserLeaderboard[]> | undefined> => {
  return api
    .get(`/v1/leaderboards/${id}/pages`, { params: { page, size, sort } })
    .then((res) => res.data);
};

export const getLeaderboardUsersByType = (
  type: LeaderboardContestType,
  { page = 0, size = 10, sort = 'asc' }: PageableOptions = {}
): Promise<PageableRes<UserLeaderboard[]> | undefined> => {
  return api
    .get(`/v1/leaderboards/type/${type}/pages`, { params: { page, size, sort } })
    .then((res) => res.data);
};

export const getLeaderboardsTop = () => {
  return api
    .get<WinnerByLBCategory[] | undefined>('/v1/leaderboards/top')
    .then((res) => res.data);
};

export const getLeaderboardMarketItems = (leaderboardId: number) => {
  return api
    .get<MarketItem[]>(`/v1/leaderboards/${leaderboardId}/market`)
    .then((res) => res.data);
};

export const getLeaderboardTasks = (tasksGroup: string) => {
  return api.get<Tasks>(`/v3/wheel/tasks?group=${tasksGroup}`).then((res) => res.data);
};

export const claimLeaderboardPrizes = (leaderboardId: number) => {
  return api
    .put<Prize[]>(`/v1/leaderboards/${leaderboardId}/prize/claim`)
    .then((res) => res.data);
};

export const claimLeaderboardWelcomePrizes = (leaderboardId: number) => {
  return api
    .put<Prize[]>(`/v1/leaderboards/${leaderboardId}/prize/welcome/claim`)
    .then((res) => res.data);
};

export const claimLeaderboardAllPrizes = (leaderboardId: number) => {
  return api
    .put<Prize[]>(`/v1/leaderboards/${leaderboardId}/prize/claim/all`)
    .then((res) => res.data);
};

export const reportUser = async (userId: number): Promise<void> => {
  await api.post(`v1/fights/report/${userId}`);
};

export const getFight = async (): Promise<Fights> => {
  return await api.get('v1/fights').then((res) => res.data);
};

export const accessFight = async (): Promise<Fights> => {
  return await api.put('v1/fights/access').then((res) => res.data);
};
